import { IssueCaseDoc, OrderDoc } from '@gooduncles/gu-app-schema';
import { Modal, Tabs } from 'antd';
import { FC, useState } from 'react';

import { buildIssuePanelModalData, IssuePanelModalData } from 'src/utils/issue/issue-util';

import { useRecentValidIssueCases } from 'src/hooks/subscription/useRecentValidIssueCases';
import { useRecentValidOrders } from 'src/hooks/subscription/useRecentValidOrders';

import OrderAndLogView from 'src/atomic-components/organisms/OrderAndLogView/OrderAndLogView';

import RecentIssueCaseList from 'src/components/Crm/CrmBoard/components/StoreSection/RecentIssueCaseList';
import RecentOrderList from 'src/components/Crm/CrmBoard/components/StoreSection/RecentOrderList';
import IssuePanelModal from 'src/components/Issue/IssuePanelModal';

import styles from './StoreInfoPanel.module.scss';

interface StoreInfoPanelProps {
  storeId: string | null;
}

interface SelectedIssue {
  id: string;
  panelData: IssuePanelModalData;
}

const StoreInfoPanel: FC<StoreInfoPanelProps> = ({ storeId }) => {
  const { orders, isLoading: ordersLoading } = useRecentValidOrders(storeId);
  const { issueCases, isLoading: issuesLoading } = useRecentValidIssueCases(storeId);

  const [selectedOrderId, setSelectedOrderId] = useState<string | null>(null);
  const [selectedIssue, setSelectedIssue] = useState<SelectedIssue | null>(null);

  const handleIssueCaseSelect = (issueCase: IssueCaseDoc) => {
    setSelectedIssue({
      id: issueCase._id,
      panelData: buildIssuePanelModalData(issueCase._id, issueCase.sourceType, issueCase.sourceId),
    });
  };

  if (!storeId) {
    return <div className={styles.emptyState}>매장을 선택하면 정보가 표시됩니다.</div>;
  }

  const tabItems = [
    {
      key: 'order',
      label: '주문',
      children: (
        <RecentOrderList
          orders={orders}
          isLoading={ordersLoading}
          selectedOrderId={selectedOrderId}
          onOrderSelect={(order: OrderDoc) => setSelectedOrderId(order._id)}
        />
      ),
    },
    {
      key: 'issue',
      label: '이슈',
      children: (
        <RecentIssueCaseList
          issueCases={issueCases}
          isLoading={issuesLoading}
          selectedIssueCaseId={selectedIssue?.id ?? null}
          onIssueCaseSelect={handleIssueCaseSelect}
        />
      ),
    },
  ];

  return (
    <div className={styles.panel}>
      <Tabs defaultActiveKey='order' className={styles.tabs} items={tabItems} />
      {selectedIssue?.panelData && (
        <IssuePanelModal open onClose={() => setSelectedIssue(null)} {...selectedIssue.panelData} />
      )}
      <Modal
        open={!!selectedOrderId}
        width={900}
        centered
        styles={{ body: { height: '80vh', overflow: 'scroll' } }}
        onCancel={() => setSelectedOrderId(null)}
        okButtonProps={{ style: { display: 'none' } }}
        cancelText='닫기'
        closable={false}
      >
        {selectedOrderId && <OrderAndLogView orderId={selectedOrderId} />}
      </Modal>
    </div>
  );
};

export default StoreInfoPanel;
